<template>
  <div
    class="sub-navigation container"
    v-if="!isAuthorized"
  >
    <span class="sub-navigation__header text--lg text--semibold">
      {{ $t('navigation.freeInvoice') }}
    </span>

    <ul class="sub-navigation__list">
      <li
        v-for="link in links"
        :key="link.slug"
      >
        <Dropdown
          placement="bottom-start"
          trigger="hover"
        >
          <Anchor
            :href="`/${link.path}`"
            :class="['sub-navigation__link', { 'active': hasActiveClass(link.path)}]"
          >
            {{ link.title }}
          </Anchor>

          <DropdownMenu
            :visible-arrow="false"
            class="el-dropdown-menu--new-design"
            slot="dropdown"
          >
            <DropdownItem
              :key="item.path"
              new-design
              v-for="item in link.submenu"
            >
              <Anchor :href="`/${item.path}`">
                {{ item.title }}
              </Anchor>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    links: [],
  }),
  computed: {
    ...mapGetters('auth', [
      'isAuthorized',
    ]),
  },
  methods: {
    hasActiveClass(route) {
      return (this.$route.path).includes(route);
    },
  },
  mounted() {
    this.links = window.postsRoutes;
  },
};
</script>

<style lang="scss" scoped>
.sub-navigation {
  display: flex;
  padding-block: rem(12px) rem(8px);

  &.active {
    color: $--color-primary-dark-3;
  }

  @media only screen and (max-width: $--md - 1) {
    padding: 0;
  }
}

.sub-navigation__header {
  @media only screen and (max-width: $--md - 1) {
    display: none;
  }
}

.sub-navigation__list {
  column-gap: 2rem;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  list-style: none;
  margin-bottom: 0;
  padding: 0;

  @media only screen and (max-width: $--md - 1) {
    display: block;
    padding: 16px 20px;

    li {
      margin-bottom: 40px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}

.sub-navigation__link {
  font-size: rem(14px);
  font-weight: 600;
  color: $--color-text-blue;
  transition: color .2s ease-in-out, text-decoration-color .2s ease-in-out;

  &.active {
    color: $--color-primary-dark-3;
  }
}

.el-dropdown-menu {
  @media only screen and (max-width: $--md - 1) {
    display: none;
  }

  :deep() {
    .el-dropdown-menu__item--new-design {
      padding: 0 16px;
      margin: 14px 0;

      a {
        color: inherit;
      }
    }
  }
}
</style>
